
























































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'

settings =
  name: 'VendorListingShow'

  resources:
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/:vendorListingId'

  vue:
    props: ['vendorListingId']

    components: { SuperContainerView, Back }

    methods:
      hiDeactivate: ->
        @triggerResource 'vendor_listing', 'deactivate'
      hiReactivate: ->
        @triggerResource 'vendor_listing', 'reactivate'

export default VueOptions.vue settings
